import { ReactNode } from 'react'

import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import { Box, Paper, Skeleton, Stack, Tooltip, Typography } from '@mui/material'
import { alpha } from '@mui/material/styles'

interface Props {
  title: string
  value: string
  color: string
  icon: ReactNode
  caption?: string
  subCaption?: string
  info?: string
  loading?: boolean
}

export const SupplierActivationKpiCard = ({
  title,
  value,
  color,
  icon,
  caption,
  subCaption,
  info,
  loading,
}: Props) => (
  <Paper
    variant='outlined'
    sx={{
      p: 2.5,
      height: '100%',
      borderRadius: 2,
      bgcolor: alpha(color, 0.05),
      borderColor: alpha(color, 0.25),
    }}>
    <Stack direction='row' spacing={2} alignItems='flex-start'>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: 48,
          height: 48,
          borderRadius: '50%',
          flexShrink: 0,
          color,
          backgroundColor: alpha(color, 0.12),
        }}>
        {icon}
      </Box>

      <Box sx={{ minWidth: 0 }}>
        <Stack direction='row' spacing={0.5} alignItems='flex-start'>
          <Typography variant='body2' color='text.secondary' fontWeight={600}>
            {title}
          </Typography>
          {info && (
            <Tooltip title={info}>
              <InfoOutlinedIcon
                fontSize='small'
                sx={{ color: 'text.disabled', flexShrink: 0, mt: '2px' }}
              />
            </Tooltip>
          )}
        </Stack>

        {loading ? (
          <Skeleton width={90} height={44} />
        ) : (
          <Typography
            variant='h4'
            fontWeight={700}
            sx={{ color, lineHeight: 1.3, whiteSpace: 'nowrap' }}>
            {value}
          </Typography>
        )}

        {caption && (
          <Typography variant='caption' color='text.secondary' display='block'>
            {caption}
          </Typography>
        )}

        {subCaption && (
          <Typography variant='caption' color='text.disabled' display='block'>
            {subCaption}
          </Typography>
        )}
      </Box>
    </Stack>
  </Paper>
)
